

export default function SantiRulesAll() {
    return(
        <section id="santi">
            <h2>La mejor sección super secreta</h2>
            <div>
                <input placeholder="DNI"/>
                <button>Cargar asistencia</button>
            </div>
        </section>
    )
}